import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { MapsService } from 'src/app/services/maps.service';
import { ReplaySubject, Subscription } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators'; 
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import * as moment from 'moment';
import { ErrorType } from 'src/app/enums/error-type.enum';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'fury-create-customer-agreement',
  templateUrl: './create-customer-agreement.component.html',
  styleUrls: ['./create-customer-agreement.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
  providers: [DecimalPipe]
})
export class CreateCustomerAgreementComponent implements OnInit {

  createCustomerAgreementForm!: any;
  @ViewChild('location', { static: false }) public location!: ElementRef;
  @ViewChild('mailingAddress', { static: false })
  public mailingAddress!: ElementRef;
  private destroyed: ReplaySubject<boolean> = new ReplaySubject(1);
  mainPlans: any = [];
  optionaalPlans: any = [];
  mainPlanCoverItemList: any = [];
  optionalPlanCoverItemList: any = [];
  propertyTypeList: any = [];
  propertySizeList: any = [];
  stateList: any = [];
  isSameMailingAddress: boolean = false;
  versionNo: number = 1;
  isShowUnitNo: boolean = false;
  isShowMailingUnitNo:boolean = false;
  upcomingPayment: any = [];
  date = new Date();
  versionId!:any;
  constructor(
    public apiservice: ApiService,
    private router: Router,
    private mapsService: MapsService,
    private decimalPipe: DecimalPipe,
    private el: ElementRef,
    private ar: ActivatedRoute
  ) {
    this.versionId = this.ar.snapshot.paramMap.get("id");
    if(this.versionId){
      this.getAgreementData();
    }    
    this.versionNo = window.history.state?.agreementVersion ?  window.history.state.agreementVersion + 1 : 1;
  }
  getAgreementData(){
    this.apiservice.get(`admin/customer-agreement/get-customer-agreement/${this.versionId}`).subscribe((res:any)=>{
      if (res?.body) {
        const details = res.body?.customerAgreement;
        this.versionNo = details?.agreementVersion + 1;
        this.isSameMailingAddress = details?.propertyAddress === details?.propertyAddress;
        
        this.createCustomerAgreementForm.patchValue({
          stateId: details?.state?.stateId,
          stateCode: details?.stateCode,
          agreementNumber: details?.agreementNumber,
          agreementPurchaseDate: details?.agreementPurchaseDate,
          firstName: details?.firstName,
          lastName: details?.lastName,
          phoneNumber: details?.phoneNumber,
          emailAddress: details?.emailAddress,
          planPropertyTypeId: details?.planPropertyType?.planPropertyTypeId,
          planPropertySizeId: details?.planPropertySize?.planPropertySizeId,
          mainPlanId: details?.mainPlan?.planOptionalItemCategoryId,
          mainPlanItems:details?.mainPlan?.coveredItems.map((e:any)=> e.planCoverItemId),
          optionalPlanId: details?.optionalPlan?.planOptionalItemCategoryId,
          serviceFee: Number.parseFloat(details?.serviceFee),
          coverageTerm:  details?.coverageTerm,
          freeMonth: details?.freeMonth || '',
          waitingPeriod: details?.waitingPeriod,
          agreementPrice: details?.agreementPrice,
          surchargeAmount: details?.surchargeAmount,
          paymentType: details?.paymentType,
          paymentMethod: details?.paymentMethod,
          dayOfMonthlyPayment: details?.dayOfMonthlyPayment,
          paymentInformation: details?.paymentInformation,
          escrowDueDate: details?.escrowDueDate || '',
          totalCost: details?.totalAmount,
          downPaymentAmount: details?.downPaymentAmount,
          remainingBalance: details?.remainingAmount || '',
          propertyAddress: {
            streetAddress: details?.propertyAddress?.streetAddress,
            unitNumber: details?.propertyAddress?.unitNumber,
            state: details?.propertyAddress?.state,
            city: details?.propertyAddress?.city,
            zip: details?.propertyAddress?.zip,
          },
          mailingAddress: {
            streetAddress: details?.mailingAddress?.streetAddress,
            unitNumber: details?.mailingAddress?.unitNumber,
            state: details?.mailingAddress?.state,
            city: details?.mailingAddress?.city,
            zip: details?.mailingAddress?.zip,
          }
        })
        if(details?.propertyAddress?.unitNumber){
          this.isShowUnitNo = true;
        }
        if(details?.mailingAddress?.unitNumber){
          this.isShowMailingUnitNo = true;
        }
      }
      
    })
   
  }
  ngOnInit(): void {
    this.agreementFormInit();
    this.getMainPlan();
    this.getOptionalPlan();
    this.getPropertyType();
    this.getPropertySizeList();
    this.getStateList();
   
    
    this.createCustomerAgreementForm.get('mainPlanId')?.valueChanges.subscribe((res:any)=>{
      
      this.getMainPlanCoverItemList(res);
    });
    this.createCustomerAgreementForm.get('optionalPlanId')?.valueChanges.subscribe((res:any)=>{
      this.getOptionalPlanCoverItemList(res);
     
      
    })
    this.createCustomerAgreementForm.get('totalCost')?.valueChanges.subscribe((res: any) => {        
        if (this.createCustomerAgreementForm.value.coverageTerm === 'Monthly') {
          this.createCustomerAgreementForm.patchValue({
            downPaymentAmount: (res/12).toFixed(2),
          });
        } else {
          this.createCustomerAgreementForm.patchValue({
            downPaymentAmount: res,
          });
        }
        this.createCustomerAgreementForm.controls['downPaymentAmount'].setValidators([Validators.max(this.createCustomerAgreementForm.get('totalCost').value)]);
      });

    this.createCustomerAgreementForm.get('downPaymentAmount')?.valueChanges.subscribe((res: any) => {      
      this.createCustomerAgreementForm.patchValue({
        remainingBalance: this.createCustomerAgreementForm.get('totalCost')?.value - res
      });
    });

    this.createCustomerAgreementForm.get('coverageTerm')?.valueChanges.subscribe((res: any) => {
      if(res === 'Monthly') {
        this.createCustomerAgreementForm.patchValue({
          paymentType: 'Monthly',
          waitingPeriod: this.createCustomerAgreementForm.get('waitingPeriod').value ? this.createCustomerAgreementForm.get('waitingPeriod').value : 0,
          freeMonth: null,
          endDate: ''
        });
      } else {
        this.createCustomerAgreementForm.patchValue({
          paymentType: 'Full Payment',
          waitingPeriod: this.createCustomerAgreementForm.get('waitingPeriod').value ? this.createCustomerAgreementForm.get('waitingPeriod').value : 0
        });
      }
      
    });

    this.createCustomerAgreementForm.get('waitingPeriod')?.valueChanges.subscribe((res: any) => {
      if(this.createCustomerAgreementForm.get('coverageTerm').value !== 'Monthly') {
        const tenure = Number(this.createCustomerAgreementForm.get('coverageTerm').value.split(' ')[0]);
        const freeMonth = this.createCustomerAgreementForm.get('freeMonth').value ? Number(this.createCustomerAgreementForm.get('freeMonth').value.split(' ')[0]) : 0;
        
        this.createCustomerAgreementForm.patchValue({
          startDate: moment().add(res, 'days').format('YYYY-MM-DD'),
          endDate: moment().add((tenure*365)+res+(freeMonth * 30), 'days').format('YYYY-MM-DD')
        });
      } else {
        this.createCustomerAgreementForm.patchValue({
          startDate: moment().add(res, 'days').format('YYYY-MM-DD'),
        });
      }
    });

    this.createCustomerAgreementForm.get('paymentType')?.valueChanges.subscribe((res: any) => {
      if(res !== 'Full Payment' && res !== 'Monthly') {
       (<FormArray>this.createCustomerAgreementForm.get('upcomingPayments')).clear()
        // Due Date Section
        const duration  =  moment(this.createCustomerAgreementForm.get('endDate').value).diff(moment(this.createCustomerAgreementForm.get('startDate').value), 'days');
        // Creating Upcoming array
        const upcomintPaymentNumber = Number(res.split(' ')[0]) - 1;
        
        [...Array(upcomintPaymentNumber).keys()].map((item: any, index: number)=>{
          const actualAmount = this.createCustomerAgreementForm.get('remainingBalance')?.value / upcomintPaymentNumber;
          (<FormArray>this.createCustomerAgreementForm.get('upcomingPayments')).push(new FormGroup({
              amountPaid: new FormControl(actualAmount, [Validators.required]),
              paymentMethod: new FormControl('credit-debit-card', [Validators.required]),
              remainingBalance: new FormControl(this.createCustomerAgreementForm.get('remainingBalance')?.value - (actualAmount * (index + 1))),
              dueDate: new FormControl(moment(this.createCustomerAgreementForm.get('startDate').value).add((index + 1), 'months').format('YYYY-MM-DD')),
          }))
        })
      }
    });

    this.createCustomerAgreementForm.get('startDate')?.valueChanges.subscribe((res: any) => {
      const duration  =  moment(this.createCustomerAgreementForm.get('endDate').value).diff(moment(this.createCustomerAgreementForm.get('startDate').value), 'days');
      
     });

     this.createCustomerAgreementForm.get('remainingBalance')?.valueChanges.subscribe((res: any) => {
      this.setUpcomingCalculation(res);
     });

    this.createCustomerAgreementForm.get('freeMonth')?.valueChanges.subscribe((res: any) => {
      if(res) {
        const freeMonth = Number(res.split(' ')[0]);
        const tenure = Number(this.createCustomerAgreementForm.get('coverageTerm').value.split(' ')[0]);
        const waitingPeriod = this.createCustomerAgreementForm.get('waitingPeriod').value;        

        
        this.createCustomerAgreementForm.patchValue({
          endDate: moment().add((tenure*365)+waitingPeriod+(freeMonth * 30), 'days').format('YYYY-MM-DD')
        });
      }
    });

    
      
  }

  setUpcomingCalculation(remainingBalance: number, chackAfterIndex?: boolean, indexToCheck?: number) {
    this.createCustomerAgreementForm.get('upcomingPayments').controls.map((controls: any, index: number)=>{
      if(chackAfterIndex) {
        if(index >= indexToCheck!) {
          if(index === indexToCheck) {
            if(indexToCheck === 0) {
            // Set remaining balance only for first element
            const actualRemaining = this.createCustomerAgreementForm.get('remainingBalance')?.value / this.createCustomerAgreementForm.get('upcomingPayments').value.length;
            const amountPaid = controls.get('amountPaid').value;  
            controls.patchValue({
                remainingBalance: (remainingBalance + ( actualRemaining - amountPaid)) >= 0 ? (remainingBalance + ( actualRemaining - amountPaid)) : 0,
              })
              controls.get('amountPaid').setValidators([Validators.max(this.createCustomerAgreementForm.get('remainingBalance')?.value)]);
            } else {   
              const remainingBalanceForOtherSection = this.createCustomerAgreementForm.get('upcomingPayments').controls[index - 1].get('remainingBalance').value - this.createCustomerAgreementForm.get('upcomingPayments').controls[index].get('amountPaid').value;         
              controls.patchValue({
                remainingBalance: remainingBalanceForOtherSection >= 0 ? remainingBalanceForOtherSection : 0,
              })
              controls.get('amountPaid').setValidators([Validators.max(this.createCustomerAgreementForm.get('upcomingPayments').controls[index - 1].get('remainingBalance').value)]);
            }
          } else {
            const amountPaidForOthers = this.createCustomerAgreementForm.get('upcomingPayments').controls[indexToCheck!].get('remainingBalance').value / (this.createCustomerAgreementForm.get('upcomingPayments').controls.length - indexToCheck! -1);
            controls.patchValue({
              amountPaid: amountPaidForOthers >= 0 ? amountPaidForOthers : 0,
            })
            controls.get('amountPaid').setValidators([Validators.max(this.createCustomerAgreementForm.get('upcomingPayments').controls[index - 1].get('remainingBalance').value)]);
          }
        }
      } else {
        const amountPaidForNormal = remainingBalance / this.createCustomerAgreementForm.get('upcomingPayments').value.length;
        const remainingBalanceNormal = remainingBalance - ((remainingBalance / this.createCustomerAgreementForm.get('upcomingPayments').value.length)*(index + 1));
        controls.patchValue({
          amountPaid: amountPaidForNormal >= 0 ? amountPaidForNormal : 0,
          remainingBalance: remainingBalanceNormal >= 0 ? remainingBalanceNormal : 0,
          dueDate: moment(this.createCustomerAgreementForm.get('startDate').value).add((index + 1), 'months').format('YYYY-MM-DD'),
        })
        controls.get('amountPaid').setValidators([Validators.max(remainingBalance)]);
      }
    })
  }

  changeAmountPaid(index: number, controls: any) {
    const acturalRemainingPrice = this.createCustomerAgreementForm.get('remainingBalance').value - ((this.createCustomerAgreementForm.get('remainingBalance').value / this.createCustomerAgreementForm.get('upcomingPayments').value.length)*(index + 1))   
    this.setUpcomingCalculation(acturalRemainingPrice, true, index);
  }

  agreementFormInit() {
    this.createCustomerAgreementForm = new FormGroup({
      stateId: new FormControl('', [Validators.required]),
      stateCode: new FormControl('', [Validators.required]),
      agreementNumber: new FormControl('', [Validators.required]),
      agreementPurchaseDate: new FormControl(moment().format('YYYY-MM-DD'), [Validators.required]),
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
      phoneNumber: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[2-9][0-8]\d{1}[2-9]\d{2}\d{4}$/),
      ]),
      emailAddress: new FormControl('', [
        Validators.required,
        Validators.pattern(
          /^[a-zA-Z0-9\s._%+-]+@[a-z0-9\s.-]+\.[a-z\s]{2,66}\s*$/
        ),
      ]),
      propertyAddress: new FormGroup({
        unitNumber: new FormControl(''),
        streetAddress: new FormControl('', [Validators.required]),
        state: new FormControl(''),
        city: new FormControl(''),
        zip: new FormControl(''),
      }),
      planPropertyTypeId: new FormControl('', [Validators.required]),
      planPropertySizeId: new FormControl('', [Validators.required]),
      mainPlanId: new FormControl('', [Validators.required]),
      mainPlanItems: new FormControl([], [Validators.required]),
      optionalPlanId: new FormControl('', [Validators.required]),
      optionalPlanItems: new FormControl([], [Validators.required]),
      serviceFee: new FormControl('', [Validators.required]),
      coverageTerm: new FormControl('', [Validators.required]),
      freeMonth: new FormControl(null),
      waitingPeriod: new FormControl('', [Validators.required]),
      startDate:  new FormControl('', [Validators.required]),
      endDate:  new FormControl(''),
      mailingAddress: new FormGroup({
        unitNumber: new FormControl(''),
        streetAddress: new FormControl('', [Validators.required]),
        state: new FormControl(''),
        city: new FormControl(''),
        zip: new FormControl(''),
      }),
      agreementPrice: new FormControl('', [Validators.required, Validators.min(0)]),
      surchargeAmount: new FormControl('', [Validators.required, Validators.min(0)]),
      paymentType: new FormControl('', [Validators.required]),
      paymentMethod: new FormControl('', [Validators.required]),
      dayOfMonthlyPayment: new FormControl(this.date.getDate() > 28 ? 15 : this.date.getDate()),
      paymentInformation: new FormControl(''),
      escrowDueDate: new FormControl(''),
      totalCost: new FormControl('', [Validators.min(0)]),
      downPaymentAmount: new FormControl('', [Validators.min(0)]),
      remainingBalance: new FormControl(''),
      upcomingPayments: new FormArray([])
    });
  }
  ngAfterViewInit() {
    setTimeout(() => {
      if (this.location)
        this.mapsService.autoFillLocation(
          this.location,
          'propertyAddress'
        );
      if (this.mailingAddress)
        this.mapsService.autoFillLocation(
          this.mailingAddress,
          'mailingAddress'
        );
    }, 200);
    this.mapsService.getaddressEvent
      .pipe(takeUntil(this.destroyed))
      .subscribe((res: any) => {
        if (res) {
          this.createCustomerAgreementForm.patchValue({
            [res.root]: {
              streetAddress: res?.address,
              state: res?.state,
              city: res?.city,
              zip: res?.zipcode,
            },
          });
        }
      });
  }
  unitNoChange() {
    if (!this.isShowUnitNo) {
      this.isShowUnitNo = true;
      this.createCustomerAgreementForm
        .get('propertyAddress.unitNumber')
        ?.setValidators(Validators.required);
    } else {
      this.isShowUnitNo = false;
      this.createCustomerAgreementForm.patchValue({
        propertyAddress: {
          unitNumber: '',
        },
      });
      this.createCustomerAgreementForm
        .get('propertyAddress.unitNumber')
        ?.clearValidators();
    }
  }
  mailingUnitNoChange() {
    if (!this.isShowMailingUnitNo) {
      this.isShowMailingUnitNo = true;
      this.createCustomerAgreementForm
        .get('mailingAddress.unitNumber')
        ?.setValidators(Validators.required);
    } else {
      this.isShowMailingUnitNo = false;
      this.createCustomerAgreementForm.patchValue({
        mailingAddress: {
          unitNumber: '',
        },
      });
      this.createCustomerAgreementForm
        .get('mailingAddress.unitNumber')
        ?.clearValidators();
    }
  }
  checkSameMailAddress() {
    if (!this.isSameMailingAddress) {
      this.isSameMailingAddress = true;
      this.createCustomerAgreementForm.patchValue({
        mailingAddress: {
          unitNumber:
            this.createCustomerAgreementForm.value.propertyAddress?.unitNumber,
          streetAddress:
            this.createCustomerAgreementForm.value.propertyAddress
              ?.streetAddress,
          state: this.createCustomerAgreementForm.value.propertyAddress?.state,
          city: this.createCustomerAgreementForm.value.propertyAddress?.city,
          zip: this.createCustomerAgreementForm.value.propertyAddress?.zip,
        },
      });
    } else {
      this.isSameMailingAddress = false;
      this.createCustomerAgreementForm.patchValue({
        mailingAddress: {
          unitNumber: '',
          streetAddress: '',
          state: '',
          city: '',
          zip: '',
        },
      });
    }
  }
  getTotalCostChange() {
    let cost =
      this.createCustomerAgreementForm.value.agreementPrice +
      this.createCustomerAgreementForm.value.surchargeAmount;
    this.createCustomerAgreementForm.patchValue({
      totalCost: cost,
    });
  }

  getStateCode(event: any) {
    this.createCustomerAgreementForm.patchValue({
      stateCode: this.decimalPipe.transform(this.stateList.findIndex((x: any)=> x.stateId === event.value) + 1, '3.0'),
    });
  }

  getMainPlan() {
    this.apiservice
      .get(
        'admin/plan/optional-item-category/get-all-optional-item-categories?type=main&page=1&size=100'
      )
      .subscribe(
        (res: any) => {
          if (res.body) {
            this.mainPlans = res.body.planOptionalItemCategories.data;
            if(this.versionId){
              let mainPlanId = this.createCustomerAgreementForm.controls['mainPlanId'].value;
              if(this.mainPlans){

                let selectMainPlan = this.mainPlans.filter((elm: any) => {
                  return elm.planOptionalItemCategoryId === mainPlanId;
                });
                let tempCoverPlan: any = selectMainPlan[0]?.coveredItems.map((item: any) => {
                  return { ...item, isChecked: true };
                });
                if(tempCoverPlan){
                  let coverId = tempCoverPlan.filter((e: any) => {
                    if (e.isChecked === true) {
                      return e.planCoverItemId;
                    }
                  })
                  .map((e: any) => e.planCoverItemId);
                this.createCustomerAgreementForm.patchValue({
                  mainPlanItems: coverId,
                });
                this.mainPlanCoverItemList = tempCoverPlan;
                }
               
              }
            }
          }
        },
        (err) => {}
      );
  }

  getOptionalPlan() {
    this.apiservice
      .get(
        'admin/plan/optional-item-category/get-all-optional-item-categories?type=optional&page=1&size=100'
      )
      .subscribe(
        (res: any) => {
          if (res.body) {
            this.optionaalPlans = res.body.planOptionalItemCategories.data;
            if(this.versionId){
              let optionalPlanId = this.createCustomerAgreementForm.controls['optionalPlanId'].value;
              let selectOptionalPlan = this.optionaalPlans.filter((elm: any) => {
                return elm.planOptionalItemCategoryId === optionalPlanId;
              });
              let tempCoverPlan = selectOptionalPlan[0]?.coveredItems.map((item: any) => {
                return { ...item, isChecked: true };
              });
              if(tempCoverPlan){
                let coverId = tempCoverPlan
                .filter((e: any) => {
                  if (e.isChecked === true) {
                    return e.planCoverItemId;
                  }
                })
                .map((e: any) => e.planCoverItemId);
              this.createCustomerAgreementForm.patchValue({
                optionalPlanItems: coverId,
              });
              this.optionalPlanCoverItemList = tempCoverPlan;
              }
            }
          }
        },
        (err) => {}
      );
  }

  getPropertyType() {
    this.apiservice
      .get('admin/plan/property-type/get-property-types?page=1&size=100')
      .subscribe(
        (res: any) => {
          if (res.body) {
            this.propertyTypeList = res.body?.planPropertyTypes?.data;
          }
        },
        (err) => {}
      );
  }

  getPropertySizeList() {
    this.apiservice
      .get('admin/plan/property-size/get-property-sizes?page=1&size=100')
      .subscribe(
        (res: any) => {
          if (res.body) {
            this.propertySizeList = res.body?.planPropertySizes?.data;
          }
        },
        (err) => {}
      );
  }


  getStateList() {
    this.apiservice.get('admin/state/get-all-states?page=1&size=200').subscribe(
      (res: any) => {
        if (res.body) {
         
          this.stateList = res.body?.states?.data;
        }
      },
      (err) => {}
    );
  }

  getMainPlanCoverItemList(id: any) {
    let selectMainPlan = this.mainPlans.filter((elm: any) => {
      return elm.planOptionalItemCategoryId === id;
    });
    let tempCoverPlan:any = selectMainPlan[0]?.coveredItems.map((item: any) => {
      return { ...item, isChecked: true };
    });
    if(tempCoverPlan){
      let coverId = tempCoverPlan
      .filter((e: any) => {
        if (e.isChecked === true) {
          return e.planCoverItemId;
        }
      })
      .map((e: any) => e.planCoverItemId);
    this.createCustomerAgreementForm.patchValue({
      mainPlanItems: coverId,
    });
    this.mainPlanCoverItemList = tempCoverPlan;
    }
  }

  getOptionalPlanCoverItemList(id: string) {
    let selectOptionalPlan = this.optionaalPlans.filter((elm: any) => {
      return elm.planOptionalItemCategoryId === id;
    });
    let tempCoverPlan = selectOptionalPlan[0]?.coveredItems.map((item: any) => {
      return { ...item, isChecked: true };
    });
    if(tempCoverPlan){
      let coverId = tempCoverPlan
      .filter((e: any) => {
        if (e.isChecked === true) {
          return e.planCoverItemId;
        }
      })
      .map((e: any) => e.planCoverItemId);
    this.createCustomerAgreementForm.patchValue({
      optionalPlanItems: coverId,
    });
    this.optionalPlanCoverItemList = tempCoverPlan;
    }
   
  }

  mainCoverItemChange(event: any, id: any) {
    const { name, checked } = event.target;
    let tempItem = this.mainPlanCoverItemList.map((item: any) => {
      if (item.planCoverItemId === id) {
        return { ...item, isChecked: checked };
      }
      return item;
    });
    let coverId = tempItem
      .filter((el: any) => {
        if (el.isChecked === true) {
          return el.planCoverItemId;
        }
      })
      .map((e: any) => e.planCoverItemId);
    this.createCustomerAgreementForm.patchValue({
      mainPlanItems: coverId,
    });
    this.mainPlanCoverItemList = tempItem;
  }

  optionalCoverItemChange(event: any, id: any) {
    const { name, checked } = event.target;
    let tempItem = this.optionalPlanCoverItemList.map((item: any) => {
      if (item.planCoverItemId === id) {
        return { ...item, isChecked: checked };
      }
      return item;
    });
    
    let coverId = tempItem
      .filter((el: any) => {
        if (el.isChecked === true) {
          return el.planCoverItemId;
        }
      })
      .map((e: any) => e.planCoverItemId);
    this.createCustomerAgreementForm.patchValue({
      optionalPlanItems: coverId,
    });
    this.optionalPlanCoverItemList = tempItem;
    
    
  }
  createAgreement() {
    if (this.createCustomerAgreementForm.valid) {
      let dataset = this.createCustomerAgreementForm.value;
      if(this.createCustomerAgreementForm.get('coverageTerm').value === 'Monthly') {
        delete dataset.freeMonth;
        delete dataset.escrowDueDate;
        delete dataset.downPaymentAmount;
        delete dataset.upcomingPayments;
      } else {
        delete dataset.dayOfMonthlyPayment;
      }
      if(this.createCustomerAgreementForm.get('paymentMethod').value === 'credit-debit-card'){
        delete dataset.escrowDueDate;
      }
      if(this.createCustomerAgreementForm.get('paymentMethod').value === 'escrow-invoice'){
        delete dataset.paymentInformation;
      }
      if(this.createCustomerAgreementForm.get('paymentType').value === 'Full Payment'){
        delete dataset.upcomingPayments;
      }
     if(!this.versionId){
      this.apiservice.post('admin/customer-agreement/create-customer-agreement', dataset).subscribe(
        (res: any) => {
          if (res.body) {
            this.apiservice.alert(res.body.message, ErrorType.Success);
            this.router.navigate(['admin', 'customer-agreement', 'customer-detail', dataset.agreementNumber]);
          }
        }, 
        (error) => {
          this.apiservice.alert(error.message, ErrorType.Error)
        }
      )
     } else{
      this.apiservice.patch(`admin/customer-agreement/update-customer-agreement/${this.versionId}`, dataset).subscribe(
        (res:any)=>{
        if(res.body){
          this.apiservice.alert(res.body.message, ErrorType.Success);
          this.router.navigate(['admin', 'customer-agreement', 'customer-detail', dataset.agreementNumber]);
        }
      },
      (error) =>{
        this.apiservice.alert(error.message, ErrorType.Error)
      })
     }
     
    } else {
      this.createCustomerAgreementForm.markAllAsTouched();
      const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector("input.ng-invalid");
      const textAreaInvalidControl: HTMLElement = this.el.nativeElement.querySelector("textarea.ng-invalid");
      if(firstInvalidControl){firstInvalidControl.focus()} 
      if(!firstInvalidControl && textAreaInvalidControl){textAreaInvalidControl.focus()}
    }
  }

  ngOnDestroy(): void {
    this.destroyed.next(true);
    this.destroyed.unsubscribe();
    this.mapsService.setAddressEvent(false);
  }

}
